export class ColumnWithOrdering {
    constructor(columnId, orderingDirection) {
        this._columnId = columnId;
        this._orderingDirection = orderingDirection;
    }

    columnId() {
        return this._columnId;
    }

    orderingDirection() {
        return this._orderingDirection;
    }
}